App.namespace('components.accordion', () => {
  const accordions = document.querySelectorAll('.ds-accordion');
  const accordionTriggers = document.querySelectorAll('.ds-accordion__trigger');

  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      accordions.forEach((accordion) => {
        if (accordion !== trigger.parentElement) {
          accordion.classList.remove('ds-accordion--open');
        } else {
          trigger.parentElement.classList.toggle('ds-accordion--open');
        }
      });

      const isExpanded = trigger.parentElement.classList.contains('ds-accordion--open');
      trigger.setAttribute('aria-expanded', `${isExpanded}`);
    });
  });
});
